import MenuItemSale from 'records/MenuItemSale';
import Base from 'records/Base';

import {
  MENU_ITEM_SALE_ASYNC_ACTION_START,
  MENU_ITEM_SALE_ASYNC_ACTION_ERROR,
  MENU_ITEM_SALE_ASYNC_UPDATE_ACTION_SUCCESS,
  MENU_ITEM_SALE_UPDATE_ACTION_SUCCESS,
  MENU_ITEM_SALE_RESET_STATE,
} from 'actions/menuItemSale';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new MenuItemSale(),
});

const actionsMap = {
  [MENU_ITEM_SALE_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_ITEM_SALE_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_ITEM_SALE_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new MenuItemSale(action.data),
    });
  },
  [MENU_ITEM_SALE_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return new Base({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [MENU_ITEM_SALE_RESET_STATE]: () => {
    return initialState;
  },
};

export default function menuItemSale(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
